export default "__VITE_ASSET__E8WJlpNi__"